import { render, staticRenderFns } from "./logisticsInfo.vue?vue&type=template&id=0f32e4c6&scoped=true&"
import script from "./logisticsInfo.vue?vue&type=script&lang=ts&"
export * from "./logisticsInfo.vue?vue&type=script&lang=ts&"
import style0 from "./logisticsInfo.vue?vue&type=style&index=0&id=0f32e4c6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f32e4c6",
  null
  
)

export default component.exports